export {
  Staff_DropInClinicRequestType as RequestType,
  Staff_DropInClinicRequestStatus as RequestStatus,
} from 'src/generated/gql/graphql';

export enum PopInClinicSection {
  Queue = 'queue',
  Availability = 'availability',
}
